import BreadcrumbsSchema from "./BreadcrumbsSchema";

export type { BreadcrumbsSchemaProps } from "./BreadcrumbsSchema.d";
export default BreadcrumbsSchema;
